import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { EntitySelectorData, EntitySelectorDialogComponent } from 'src/app/components/entities/entity-selector.dialog.component';
import { Exhibitor, exhibitorDisplayTypes, ExhibitorStand } from 'globals/store/exhibitors.data';
import { exhibitorStandIdsByExhibitorIdReselector, exhibitorStandIdsByProgramIdFactory, exhibitorStandIdsByProgramIdReselector, standSelectorDialogDataByProgramAndExhibitorIdReselector } from 'src/app/store/reselectors/exhibitors.reselector';
import { Dictionary } from '@ngrx/entity';
import { Program } from 'globals/store/programs.data';
import { StatusType } from 'globals/store/share.data';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { getXYFromEventAndWidth } from 'src/app/helpers/helpers';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ManageExhibitorStandData, ManageExhibitorStandDialogComponent } from './manage-exhibitor-stand';
import { NestedProgramInfo } from '../../store/reselectors/performerSponsors.reselector';
import { SessionSelectorData, SessionSelectorDialogComponent } from '../../components/performers/session-selector.dialog.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { StatusWrapperComponent } from 'src/app/components/wrappers/status-wrapper.component';
import { SponsorCardComponent } from 'src/app/components/cards/sponsor-card.component';
import { exhibitorStandsFeature } from 'src/app/store/exhibitor.stands.era';
import { takeUntil } from 'rxjs';

type StandDotId = 'deleteFromProgram' | 'deleteFromExhibitor' | 'manage'
interface StandDotOption { name: string, id: StandDotId }
@Component({
    selector: 'exhibitor-stands',
    templateUrl: './exhibitor-stands.html',
    styleUrls: ['../../components/performers/performers.component.scss', 'exhibitors.scss', '../manage/entity-drag.scss'],
    standalone: true,
    imports: [AddManageWrapperComponent, CdkDragHandle, CdkDrag, CdkDropList, SponsorCardComponent, StatusWrapperComponent, CommonModule, IdsToItemsPipe, IconComponent],
})
export class ExhibitorStandsComponent extends Wrapper<ExhibitorStandsComponent> implements OnInit {

  @Input() displayType
  @Input() programId: string // can only be from manage program
  @Input() exhibitorId: string // can only be from manage exhibitor

  @Input() hideTitle = false
  @Input() emptyText = 'No exhibitor stands'
  @Input() readOnly = true
  @Input() showBriefStatus = false
  @Input() fromManageDialog = true

  standSelectorForExhibitorDialogData: NestedProgramInfo[] 
  hasExhibitorStandsToChooseFrom = false;

  displayTypes = exhibitorDisplayTypes
  exhibitorStandIds: string[] = []
  programDotOptions: StandDotOption[] = [{ name: 'Remove exhibitor stand from room/location', id: 'deleteFromProgram' }, { name: 'Manage exhibitor stand', id: 'manage' }]
  exhibitorDotOptions: StandDotOption[] = [{ name: 'Remove exhibitor stand from exhibitor', id: 'deleteFromExhibitor' }, { name: 'Manage exhibitor stand', id: 'manage' }]

  exhibitors: { [eId: string]: Exhibitor }
  exhibitorStands: { [eId: string]: ExhibitorStand }
  standTypes
  programs: Dictionary<Program> = {}

  constructor(public changeDetectorRef: ChangeDetectorRef) {
    super()
    this.subProp(this.store.select('exhibitors','standTypes'), 'standTypes');
    this.subProp(this.store.select('programs', 'entities'), 'programs')
    this.subProp(this.store.select(exhibitorStandsFeature.selectEntities), 'exhibitorStands')
  }

  ngOnInit() {
    if (this.programId) this.selectProp(exhibitorStandIdsByProgramIdReselector, this.programId, 'exhibitorStandIds')
    else if (this.exhibitorId) this.selectProp(exhibitorStandIdsByExhibitorIdReselector, this.exhibitorId, 'exhibitorStandIds')
    this.subProp(this.store.select('exhibitors', 'entities'), 'exhibitors')
    if (this.exhibitorId) this.selectCallback(standSelectorDialogDataByProgramAndExhibitorIdReselector, this.exhibitorId, (standSelectorForExhibitorDialogData: NestedProgramInfo[]) => {
      console.log({ standSelectorForExhibitorDialogData});
      this.standSelectorForExhibitorDialogData = standSelectorForExhibitorDialogData;
      this.hasExhibitorStandsToChooseFrom = standSelectorForExhibitorDialogData.length > 0;
    })
  }

  dropExhibitorIds(event: any) {
    const newIds = [...this.exhibitorStandIds]
    moveItemInArray(newIds, event.previousIndex, event.currentIndex)
    if (JSON.stringify(this.exhibitorStandIds) === JSON.stringify(newIds)) return    
    this.exhibitorStandIds = newIds
    this.exhibitorService.addOrderToExhibitorStands(newIds, this.programId ? 'programIndex' : 'exhibitorIndex')
  }




  dotMenuSelection({ event, option }: { event: any, option: StandDotId }, exhibitorStand: ExhibitorStand) {
    switch (option) {
      case 'deleteFromProgram':
        this.deleteWithConfirm(exhibitorStand, event, 'program')
        break;
      case 'deleteFromExhibitor':
        this.deleteWithConfirm(exhibitorStand, event, 'exhibitor')
        break
      case 'manage':
        this.manageExhibitorStand(exhibitorStand)
        break;
      default:
        console.log(`Missing selection [${option}] from three dot menu`)
        break;
    }
  }


  changeStatus(exhibitor: Exhibitor, status: StatusType) {
    const confirmed = status === 'Confirmed'
    if (confirmed === !!exhibitor.confirmed) return
    exhibitor.confirmed = confirmed
    this.exhibitorService.updateExhibitor(exhibitor)    
  }

  async manageExhibitorStand(exhibitorStand: ExhibitorStand) {
    const data: ManageExhibitorStandData = { exhibitorStandId: exhibitorStand.id, nested: this.fromManageDialog }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageExhibitorStandDialogComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  async deleteWithConfirm(exhibitorStand: ExhibitorStand, event, type: 'program' | 'exhibitor') {
    const rect = event.target.getBoundingClientRect();
    const data: ConfirmDeleteData = {
      title: 'Remove ' + exhibitorStand.name + ' from this ' + (type === 'program' ? 'room/location' : 'exhibitor'),
      deleteButtonText: 'REMOVE',
      rect,
      bottomOffset: -45,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    await this.exhibitorService.clearIdsFromStands([  exhibitorStand.id ], this.programId ? 'program' : 'exhibitor', this.programId || this.exhibitorId)
  }



  
  addExhibitorStandThroughPopupDialog(event) {

    if (this.exhibitorId) {
      const data: SessionSelectorData = { nestedProgramList: this.standSelectorForExhibitorDialogData, ...getXYFromEventAndWidth(event, 300), exhibitorId: this.exhibitorId, isStands: true }
      this.dialog.open(SessionSelectorDialogComponent, { width: '300px', data, backdropClass: 'clear', disableClose: true })
    } else if (this.programId) {
      const entities = Object.values(this.exhibitorStands).filter(s => s.programId !== this.programId)
      const disabledEntityMessages = {}
      entities.filter(e => this.programs[e.programId]).forEach(e => disabledEntityMessages[e.id] = `Assigned to <i>${this.programs[e.programId].title}</i>`)
  
      const data: EntitySelectorData = { 
        disabledEntityMessages, 
        entities, 
        searchPlaceholder: 'Search or add exhibitor stand', 
        newMessage: 'Exhibitor stand number or name:',
        newPlaceholder: 'Exhibitor stand number or name',
        entityName: 'Exhibitor Stand', 
        rect: (<HTMLElement>event.target).getBoundingClientRect(), 
        emptyNamePlaceholder: 'Unnamed Exhibitor Stand',
        entityHolderName: 'ROOM/LOCATION'
      }
  
      openDialogGetResult(this.dialog,EntitySelectorDialogComponent, { width: '370px', data, disableClose: true, backdropClass: 'clear' }).then((selected: string[]) => {
        if (!selected) return
        this.exhibitorService.addExhibitorStands(selected, this.programId, 'program')
      })
    }
  }

}

